import { createLevelContext } from "../_lib/createLevelContext";

const { Provider, useValue } = createLevelContext("third");

export const ThirdLevelProvider = Provider;
export const useThirdLevelContext = useValue;
